import * as React from 'react';
import { Link } from '@chakra-ui/react';
import CanyouLogo from '../assets/canyou-black-logo.svg';
import { Link as GatsbyLink } from 'gatsby';

export const Logo: React.FC = () => {
  return (
    <Link as={GatsbyLink} to="/">
      <CanyouLogo width={190} />
    </Link>
  );
};
